import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const SearchMRecordListState = Immutable.fromJS({
	searchMRecordList: [],
	activePage: 1,
	itemPerPage: 100,
	totalPage: 1
});

const searchMRecordListReducer = handleActions({
	FIND_SEARCH_M_RECORD_LIST: (state, { payload }) => {
		return state.merge({
			searchMRecordList: payload.data,
			activePage: 1,
			totalPage: 1,
			itemPerPage: 100,
		})
	},
	CLEAN_SEARCH_M_RECORD_LIST: (state, { payload }) => {
		return state.merge({
			searchMRecordList: [],
			activePage: 1,
			totalPage: 1,
			itemPerPage: 100,
		})
	}
}, SearchMRecordListState);

export default searchMRecordListReducer;


// WEBPACK FOOTER //
// ./src/reducers/searchMRecordListReducer.js